export default __webpack_public_path__ + "static/media/7g.793e6dd8.svg";